import Swal from 'sweetalert2'

import { Button } from '@domain-group/suit-theme'

import { UseCampaignPayload } from '@hooks/useCampaign'

import handleCallbackAction from '@functions/handleCallbackAction'

const unpublishCampaignSwalConfig = {
  title: 'Stop Syncing?',
  text: 'Are you sure? Data will no longer be pushed to your portals.',
  icon: 'warning',
  confirmButtonText: 'Yes, withdraw it.',
  confirmButtonColor: '#e2001a',
  showCancelButton: true,
}

const publishCampaignSwalConfig = {
  title: 'Publish Campaign?',
  text: 'Are you sure? Data will be pushed to your portals.',
  icon: 'success',
  confirmButtonColor: '#43ac6a',
  confirmButtonText: 'Yes, publish it!',
  showCancelButton: true,
}

const confirmTogglePublished = (
  isPublished: boolean,
  togglePublished: UseCampaignPayload['callbacks']['togglePublished'],
) => {
  const togglePublishedPayload = {
    callbacks: {
      action: togglePublished,
    },
    toastText: isPublished ? 'Campaign Unpublished' : 'Campaign Published',
  }

  const swalConfig = isPublished ? unpublishCampaignSwalConfig : publishCampaignSwalConfig

  // @ts-expect-error TS2769
  Swal.fire(swalConfig).then(({ value }) => {
    if (value){
      handleCallbackAction(togglePublishedPayload).then((response) => {
        const { success, errors } = response

        if (!success){
          Swal.fire({
            title: 'Missing Required Fields',
            text: errors.join(', '),
            icon: 'warning',
            confirmButtonText: 'OK',
            confirmButtonColor: '#e78d2d',
          })
        }
      })
    }
  })
}

interface PublishCampaignButtonProps {
  campaignPayload: UseCampaignPayload,
}

const PublishCampaignButton = (props: PublishCampaignButtonProps) => {
  const { campaignPayload } = props

  const {
    callbacks: { togglePublished },
    campaign: { published },
  } = campaignPayload

  return (
    <Button
      buttonStyle={published ? 'secondaryUtility' : 'primaryCreate'}
      data-test-id="publishCampaignButton"
      onClick={() => confirmTogglePublished(published, togglePublished)}
      size="medium"
      width="auto"
    >
      {published ? 'Stop Syncing' : 'Publish Campaign'}
    </Button>
  )
}

export default PublishCampaignButton
